<template>
	<div id="pg4">  
		<section  class="ranking">
			<img v-responsive.xl.lg src="@/assets/landing/empleador/ranking/ranking empresas 1680x1050.jpg"
				 class="section_img">
			<img v-responsive.md src="@/assets/landing/empleador/ranking/ranking empresas 1024x768.jpg"
				 class="section_img">
			<img v-responsive.xs.sm src="@/assets/landing/empleador/ranking/ranking empresas 768x1024.jpg"
				 class="section_img">
			<div class="hyper-link">
				<div :class="isMobile ? 'row justify-content-center' : ''" >
					<a href="/empresas" :class="isMobile ? 'btn b-orange w-50 float-right' :  'btn b-orange w-50 float-right'" v-if="isLogin">
						¡Leer las reseñas!
					</a>
					<a href="/registrar/empresa" :class="isMobile ? 'btn b-orange w-50 float-right' :  'btn b-orange w-50 float-right'" v-else >
						¡Leer las reseñas!
					</a>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "ranking-empresas",
	props:['isLogin'],
	data() {
		return {
			isMobile: this.$mobile(),
		}
	}
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.ranking{
	position:relative;
}
.ranking .hyper-link a{
	font-size: large;
}
.ranking .hyper-link{
	position: absolute;
	bottom: 15%;
	right: 21%;

 
	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top: 70%;
		left: -4%;
		width: 90%;
	}
	@media only screen and (min-width: 768px) {
		bottom: 25%;
		right: 10%;
		width: 45%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 25%;
		right: 15%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 37%;
		right: 15%;
		width: 25%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 15%;
		right: 21%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 4%;
		right: 3%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		right: 21%;
	}
	// /* different techniques for iPad screening */
	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
	// 	bottom: 8%;
	// 	right: 11%;
	// }

	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
	// 	/* For landscape layouts only */
	// 	bottom: 15%;
	// 	right: 21%;
	// }
}

//.section_img {
//	width: 100%;
//}
//
///**
//  hyper-link:
// */
//.hyper-link {
//	position: absolute;
//	width: 100%;
//	right: 0;
//
//	@media only screen and (min-width: 480px) {
//		top: 108vw;
//	}
//	@media only screen and (min-width: 768px) {
//		top: 50vw;
//	}
//	@media only screen and (min-width: 960px) {
//		top: 42vw
//	}
//	@media only screen and (min-width: 1440px) {
//		top:40.5vw;
//	}
//	@media only screen and (min-width: 2000px) {
//		top: 32vw;
//	}
//	@media only screen and (max-device-width: 480px) {
//		top: 75vw;
//	}
//	@media only screen and (device-width: 768px) {
//		top: 44vw;
//	}
//	/* different techniques for iPad screening */
//	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
//		top: 83vw;
//	}
//
//	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
//		/* For landscape layouts only */
//		top: 41vw;
//	}
//}
</style>



// WEBPACK FOOTER //
// src/views/landing/empleador/ranking.vue